import { Component, JSX } from 'solid-js';
import { clsx } from 'clsx';
import { translations } from './i18n';
import FloralCorner from './FloralCorner';

declare global {
    interface Window {
        lang: "ro" | "en";
    }
}

const InviteCnt: Component<{children?: JSX.Element, class?: string, childrenBetweenVerseAndTitle?: JSX.Element}> = (props) => {
    const t = translations[window.lang ?? "ro"];

    return (
        <div class={clsx("invite-cnt", props.class)}>
            <FloralCorner class="floral-corner absolute top-0 left-0 w-[125px] z-0" corner="tl"/>
            <FloralCorner class="floral-corner absolute top-0 right-0 w-[125px] z-0" corner="tr"/>
            <FloralCorner class="floral-corner absolute bottom-0 left-0 w-[170px] z-0" corner="bl"/>
            <FloralCorner class="floral-corner absolute bottom-0 right-0 w-[170px] z-0" corner="br"/>
            <div class="main relative z-[1]">
<div class="flex flex-col items-center justify-center relative text-center invite-text-transition">
                    <div class="mb-[22px] mt-4">
                        <div class="text-sm italic">„{t.quote}"</div>
                        <div class="text-xs mt-2">{t.quoteAuthor}</div>
                    </div>
                    { props.childrenBetweenVerseAndTitle }
                    <div class="alecs-and-oana">Alecs <span class="name-heart">♥</span> Oana</div>
                </div>
                <div class="relative mb-16 invite-text-transition">{ props.children }</div>
            </div>
        </div>
    );
}

export default InviteCnt;